import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Central__Calendar_Vue",
  class: "page-layout-vue"
}
const _hoisted_2 = {
  id: "App__Calendar",
  ref: "calendarRef",
  class: "tes-calendar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelTwo = _resolveComponent("LevelTwo")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_LevelTwo, { router: _ctx.router }, null, 8 /* PROPS */, ["router"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ], 512 /* NEED_PATCH */)
  ]))
}